<template>
  <PageTable />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'expo-choiceSample',
  components: { PageTable },
}
</script>
